// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderManagementModal .MuiPaper-root.MuiDialog-paper {
  width: 640px;
  border-radius: 16px;
  height: 388px;
}

.clearBtn.MuiButtonBase-root.MuiButton-root {
  color: rgba(36, 183, 170, 1);
  margin-right: 10px;
  text-transform: none;
  font-size: 14px;
  height: 36px;
  width: 91px;
  font-weight: 500;
  border-radius: 8px;
  border: 2px solid;
  padding: 15px 8px;
  font-family: Poppins;
  border: 1px solid var(--generic-primary, #24b7aa);
  background: var(--conditional-pop-over, #fff);
}

.applyBtn.MuiButtonBase-root.MuiButton-root {
  font-weight: 500;
  border: 1px solid var(--generic-primary, #24b7aa);
  background: var(--generic-primary, #24b7aa);
  border-radius: 8px;
  text-transform: none;
  font-size: 14px;
  height: 36px;
  width: 91px;
  padding: 15px 8px;
  font-family: Poppins;
}

.modalCheckbox .MuiSvgIcon-root {
  height: 16px !important;
  width: 16px !important;
}

.dateRange .MuiInputBase-root {
  width: 200px  !important;
  margin-left: 5px;
}

.dateTimeModal .MuiPaper-root.MuiDialog-paper {
  width: 360px;
  border-radius: 16px;
  height: 570px;
}
.dateTimeRange .MuiDateCalendar-root {
  width: 310px !important;
  max-height: 320px !important;
  height: 295px !important;
  border-bottom: 1px solid lightgray;
}
.dateTimeRange .MuiInputBase-root {
  width: 290px  !important;
  margin-left: 10px !important;
}
.dateTimeRange{
  border-radius: 4px;
border: 1px solid lightgray;
height: 360px;
}

.displayTimeDirectionRow {
  display: flex;
  margin-top: 20px;
  height: 400px;
  padding: 0px 24px;
}
.dateTimeRange .MuiButtonBase-root.MuiMenuItem-root.Mui-selected{
  background: blue !important;

}

.MuiMultiSectionDigitalClockSection-root:after {
  height: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/modals/modal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB,2BAA2B;AAC3B,aAAa;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".orderManagementModal .MuiPaper-root.MuiDialog-paper {\n  width: 640px;\n  border-radius: 16px;\n  height: 388px;\n}\n\n.clearBtn.MuiButtonBase-root.MuiButton-root {\n  color: rgba(36, 183, 170, 1);\n  margin-right: 10px;\n  text-transform: none;\n  font-size: 14px;\n  height: 36px;\n  width: 91px;\n  font-weight: 500;\n  border-radius: 8px;\n  border: 2px solid;\n  padding: 15px 8px;\n  font-family: Poppins;\n  border: 1px solid var(--generic-primary, #24b7aa);\n  background: var(--conditional-pop-over, #fff);\n}\n\n.applyBtn.MuiButtonBase-root.MuiButton-root {\n  font-weight: 500;\n  border: 1px solid var(--generic-primary, #24b7aa);\n  background: var(--generic-primary, #24b7aa);\n  border-radius: 8px;\n  text-transform: none;\n  font-size: 14px;\n  height: 36px;\n  width: 91px;\n  padding: 15px 8px;\n  font-family: Poppins;\n}\n\n.modalCheckbox .MuiSvgIcon-root {\n  height: 16px !important;\n  width: 16px !important;\n}\n\n.dateRange .MuiInputBase-root {\n  width: 200px  !important;\n  margin-left: 5px;\n}\n\n.dateTimeModal .MuiPaper-root.MuiDialog-paper {\n  width: 360px;\n  border-radius: 16px;\n  height: 570px;\n}\n.dateTimeRange .MuiDateCalendar-root {\n  width: 310px !important;\n  max-height: 320px !important;\n  height: 295px !important;\n  border-bottom: 1px solid lightgray;\n}\n.dateTimeRange .MuiInputBase-root {\n  width: 290px  !important;\n  margin-left: 10px !important;\n}\n.dateTimeRange{\n  border-radius: 4px;\nborder: 1px solid lightgray;\nheight: 360px;\n}\n\n.displayTimeDirectionRow {\n  display: flex;\n  margin-top: 20px;\n  height: 400px;\n  padding: 0px 24px;\n}\n.dateTimeRange .MuiButtonBase-root.MuiMenuItem-root.Mui-selected{\n  background: blue !important;\n\n}\n\n.MuiMultiSectionDigitalClockSection-root:after {\n  height: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
